import React, { forwardRef, useCallback } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useBacklogDispatch } from '../../../state';
import { transitionZoneEnter, transitionZoneLeave } from '../../../state/actions/drag';

interface Props {
	isVisible: boolean;
}

const TransitionZone = forwardRef<HTMLDivElement, Props>(({ isVisible }: Props, ref) => {
	const dispatch = useBacklogDispatch();
	const onEnter = useCallback(() => {
		dispatch(transitionZoneEnter());
	}, [dispatch]);
	const onLeave = useCallback(() => {
		dispatch(transitionZoneLeave());
	}, [dispatch]);

	return (
		<TransitionZoneOuterContainer ref={ref} isVisible={isVisible}>
			<TransitionZoneInnerContainer
				onMouseOver={onEnter}
				onMouseOut={onLeave}
				data-testid="software-backlog.card-list.transition-zone.transition-zone-inner-container"
			/>
		</TransitionZoneOuterContainer>
	);
});

export default TransitionZone;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TransitionZoneOuterContainer = styled.div<{ isVisible: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	visibility: (props) => (props.isVisible ? 'visible' : 'hidden'),
	position: 'absolute',
	width: '100%',
	height: '100%',
	zIndex: 2,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TransitionZoneInnerContainer = styled.div({
	boxSizing: 'border-box',
	minWidth: '100%',
	position: 'relative',
	minHeight: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize - 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `2px solid ${token('color.border.focused', colors.B200)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.selected', colors.B50),
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		backgroundColor: token('color.background.selected.hovered', colors.B75),
	},
	// For whatever reason, pointerEvents is set to 'none' on
	// all Droppable refs by AK, so we need to override this here
	// to be able to register a hover on this element
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
	pointerEvents: 'all !important',
});
